<!--<div style="padding: 0px 0px;">
  <div style="display: flex; width: 100%; height: 10vh; justify-content: space-between; align-items: center; border-bottom: 2px; border-bottom-style: solid; ">
    <div style="font-size: 30px; font-weight: bold; margin-left: 15px;">
      <i class="pi pi-cog" style="font-size: 2rem"></i>
      Configuración
    </div>
    <div style="font-size: 20px; margin-right: 15px; display: flex; flex-direction: row; cursor: pointer;" routerLink="../">
      <span>Cerrar</span>
      <div style="margin-top: 3px; margin-left: 15px;">
        <i class="pi pi-times" style="font-size: 20px"></i>
      </div>
    </div>
  </div>

</div>-->
<div>
  <p-tag
    *ngIf="incomplete && isDisabled"
    value="Configuración incompleta"
    severity="warning"
    [rounded]="false"
    icon="pi pi-exclamation-triangle"
    styleClass="border-noround w-full"
    pTooltip="Llene todos los campos para continuar"
    [fitContent]="true"
    tooltipPosition="bottom"
  ></p-tag>
  <p-tag
    *ngIf="incomplete && !isDisabled"
    value="Configuración completa"
    severity="success"
    [rounded]="false"
    icon="pi pi-check-circle"
    styleClass="border-noround w-full"
    pTooltip="Ya puede cerrar esta pantalla"
    [fitContent]="true"
    tooltipPosition="bottom"
  ></p-tag>
  <div
    *ngIf="incomplete"
    class="flex w-full justify-content-end align-items-center"
  >
    <button
      pButton
      pRipple
      type="button"
      label="Cerrar"
      class="p-button-text col-1 text-xl mr-1 mt-2 p-button-secondary"
      [disabled]="isDisabled"
      icon="pi pi-times"
      (click)="goToHome()"
    ></button>
  </div>
  <div class="menu-body w-100 p-4">
    <div class="flex w-full">
      <div class="max-w-14rem">
        <div style="">
          <button
            type="button"
            (click)="selectOption(1)"
            [ngClass]="
              selectedOption === 1 ? 'selected-button' : 'unselected-button'
            "
            label="General"
            pButton
          ></button>
          <!--routerLink="../configuration/general" routerLink="../configuration/credits"  routerLink="../configuration/verification"-->
          <p-divider></p-divider>
          <button
            type="button"
            (click)="selectOption(2)"
            [ngClass]="
              selectedOption === 2 ? 'selected-button' : 'unselected-button'
            "
            label=" Casino General"
            pButton
          ></button>
          <!--routerLink="../configuration/general" routerLink="../configuration/credits"  routerLink="../configuration/verification"-->
          <button
            type="button"
            (click)="selectOption(3)"
            [ngClass]="
              selectedOption === 3 ? 'selected-button' : 'unselected-button'
            "
            label="Gestión de Créditos"
            pButton
          ></button>
          <button
            type="button"
            (click)="selectOption(4)"
            [ngClass]="
              selectedOption === 4 ? 'selected-button' : 'unselected-button'
            "
            label="Customización de Casino"
            pButton
          ></button>
          <!--<button type="button" (click)="selectVerification()" [ngClass]="isVerificationSelected === true ? 'selected-button' : 'unselected-button'" label="Verificación Usuaria" pButton></button>-->
        </div>
      </div>
      <p-divider
        class="px-6"
        [layout]="vertical ? 'vertical' : 'horizontal'"
      ></p-divider>
      <div style="width: inherit">
        <app-configuration-general
          *ngIf="selectedOption === 1"
          (messageEvent)="isDataSavedReceived($event)"
          class="fadein animation-duration-400 flex"
        ></app-configuration-general>
        <app-configuration-credits
          *ngIf="selectedOption === 3"
          class="fadein animation-duration-400"
        ></app-configuration-credits>
        <app-configuration-verification
          *ngIf="isVerificationSelected"
          class="fadein animation-duration-400"
        ></app-configuration-verification>
        <app-configuration-casino-general
          *ngIf="selectedOption === 2"
          (messageEvent)="isDataSavedReceived($event)"
          class="fadein animation-duration-400"
        ></app-configuration-casino-general>
        <app-custom-casino
          *ngIf="selectedOption === 4"
          (messageEvent)="isDataSavedReceived($event)"
          class="fadein animation-duration-400 w-full flex"
        ></app-custom-casino>
      </div>
    </div>
  </div>
</div>
